import React from 'react'
import { PageWrapperCentralized } from 'styles/common/Common.styles'
import { StyledImage, Title, Text, ContentContainer } from './NotFound.styles'
import { Button } from '@arvoreeducacao/bonsai-ds'
import { Cdn } from 'utils/assets'
import { useTranslation } from 'i18n'
import { removeCookieOnDomain } from 'utils/cookies'

const ServerError = () => {
  const { t } = useTranslation()

  const handleBackToLogin = () => {
    if (typeof window !== 'undefined' && window.ReactNativeWebView) {
      try {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'logout'
          })
        )
      } catch (error) {
        console.error('Error sending logout message:', error)
      }
    }

    removeCookieOnDomain('access_token')
    global.location.href = '/login'
  }

  return (
    <PageWrapperCentralized>
      <ContentContainer>
        <StyledImage src={Cdn.getAssetUrl2('e_404/500.png')} />
        <Title>{t('Ops!')}</Title>
        <Text>{t('Ocorreu um erro inesperado em nosso sistema.')}</Text>
        <Button
          theme={{ type: 'secondary', size: 'large' }}
          text={t('Voltar para Login')}
          onClick={handleBackToLogin}
        />
      </ContentContainer>
    </PageWrapperCentralized>
  )
}

export default ServerError
